import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import ResourceCardPreview from './ResourceCardPreview';

export default function ResourceCard({ resource }) {
  const navigate = useNavigate();

  const getSourceIcon = () => {
    if (resource.type === 'file') return 'FileText';
    if (resource.source === 'Canva') return 'Layout';
    if (resource.source?.includes('Google')) return 'Grid';
    return 'ExternalLink';
  };

  const getSourceColor = () => {
    if (resource.source === 'Canva') return 'text-[#00C4CC]';
    if (resource.source?.includes('Google')) return 'text-[#4285F4]';
    if (resource.type === 'file') return 'text-brand-green';
    return 'text-brand-cyan';
  };

  return (
    <div
      onClick={() => navigate(`/app/recursos/${resource.id}`)}
      className="group cursor-pointer flex flex-col h-full bg-[var(--bg-surface)] rounded-2xl border border-[var(--border-subtle)] shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
    >
      <div className="relative">
        <ResourceCardPreview resource={resource} />

        <div className="absolute top-3 left-3 flex flex-col gap-2 pointer-events-none">
          {resource.isUpdated && (
            <span className="px-2 py-1 gfi-gradient-bg text-brand-navy text-[8px] font-black uppercase tracking-widest rounded-full shadow-lg">
              Actualizado
            </span>
          )}
          <span className="px-2 py-1 bg-[var(--bg-surface)] text-[var(--text-main)] text-[8px] font-black uppercase tracking-widest rounded-full border border-[var(--border-subtle)] shadow-sm">
            {resource.audience}
          </span>
        </div>
      </div>

      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center gap-2 mb-2">
          <SafeIcon name={getSourceIcon()} className={`w-3.5 h-3.5 ${getSourceColor()}`} />
          <span className="text-[9px] font-black text-[var(--text-secondary)] uppercase tracking-[0.2em]">
            {resource.type === 'file' ? resource.format : resource.source}
          </span>
        </div>

        <h3 className="font-black text-[var(--text-main)] text-sm leading-tight uppercase italic tracking-tight mb-3 line-clamp-2 group-hover:gfi-gradient-text transition-all">
          {resource.title}
        </h3>

        <div className="mt-auto pt-4 border-t border-[var(--border-subtle)] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded-full bg-[var(--bg-base)] flex items-center justify-center text-[8px] font-black text-[var(--text-main)]">
              {resource.uploader.charAt(0)}
            </div>
            <span className="text-[9px] font-bold text-[var(--text-secondary)] uppercase">{resource.uploader}</span>
          </div>
          <span className="text-[9px] font-black text-[var(--text-secondary)]">V{resource.version}</span>
        </div>
      </div>
    </div>
  );
}
